export type WebflowNavigationChrome =
  | 'WEBFLOW'
  | 'WEBFLOW_NATIVE'
  | 'TRADEWING';

export const normalizeNavigationChrome = (
  value: unknown
): WebflowNavigationChrome => {
  if (value === 'TRADEWING') return 'TRADEWING';
  if (value === 'WEBFLOW_NATIVE') return 'WEBFLOW_NATIVE';
  return 'WEBFLOW';
};

/** Dynamic pages that inject the Webflow `#data-tradewing-nav` fragment. */
export const usesWebflowNavChrome = (
  chrome: WebflowNavigationChrome
): boolean => chrome === 'WEBFLOW' || chrome === 'WEBFLOW_NATIVE';

/** Keep Webflow nav CSS as designed (skip TW transparent/theme overrides). */
export const preservesWebflowNavStyles = (
  chrome: WebflowNavigationChrome
): boolean => chrome === 'WEBFLOW_NATIVE';
